import PropTypes from 'prop-types';
import cssVariables from 'src/common/styles/variables';

/* eslint-disable max-len */
const VolumeControlOffIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  fillColor,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '3 3 17 17'}
    className={className}
    data-testid="muted"
    onClick={onClick}
  >
    <g opacity="0.11">
      <rect width="24" height="24" fill="none" />
    </g>
    <path
      d="M17.88,12l1.76,1.77a.5.5,0,0,1,0,.71l-.7.7a.5.5,0,0,1-.71,0l-1.77-1.77-1.77,1.77a.48.48,0,0,1-.7,0l-.71-.7a.5.5,0,0,1,0-.71L15.05,12l-1.77-1.77a.48.48,0,0,1,0-.7L14,8.82a.48.48,0,0,1,.7,0l1.77,1.77,1.77-1.77a.5.5,0,0,1,.71,0l.7.71a.48.48,0,0,1,0,.7Zm-8-7.88a.68.68,0,0,1,1.05.5V19.38a.68.68,0,0,1-1.05.5L7,16H3.5a.49.49,0,0,1-.5-.49V8.53A.49.49,0,0,1,3.5,8H7Z"
      fill={fillColor || cssVariables['--secondary-color-5']}
      fillRule="evenodd"
    />
  </svg>
);

VolumeControlOffIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  fillColor: PropTypes.string,
};

export default VolumeControlOffIcon;
